import { languageIsEnglish } from "web/script/modules/language";
import environment from "./environment";

/**
 * Utility function to be able to tell whether membership
 * functionalities like signing up/in, wishlisting, etc
 * can be displayed / used
 */
export function canUseMembership(): boolean {
    const canUseMembership = languageIsEnglish(); // to be extended

    return canUseMembership;
}

export function shouldShowOmnibusPages(): boolean {
    return !!environment.get("showOmnibusPages");
}
